// Amazon's published Marketplace IDs and Seller Central URLs.
// https://developer-docs.amazon.com/sp-api/docs/marketplace-ids
// https://developer-docs.amazon.com/sp-api/docs/seller-central-urls
export const amazonV2Markets = [
  ["DE", "A1PA6795UKMFR9", "sellercentral-europe.amazon.com", "eu"],
  ["FR", "A13V1IB3VIYZZH", "sellercentral-europe.amazon.com", "eu"],
  ["IT", "APJ6JRA9NG5V4", "sellercentral-europe.amazon.com", "eu"],
  ["ES", "A1RKKUPIHCS9HS", "sellercentral-europe.amazon.com", "eu"],
  ["GB", "A1F83G8C2ARO7P", "sellercentral-europe.amazon.com", "eu"],
  ["NL", "A1805IZSGTT6HS", "sellercentral.amazon.nl", "eu"],
  ["BE", "AMEN7PMS3EDWL", "sellercentral.amazon.com.be", "eu"],
  ["IE", "A28R8C7NBKEWEA", "sellercentral.amazon.ie", "eu"],
  ["SE", "A2NODRKZP88ZB9", "sellercentral.amazon.se", "eu"],
  ["PL", "A1C3SOZRARQ6R3", "sellercentral.amazon.pl", "eu"],
  ["TR", "A33AVAJ2PDY3EV", "sellercentral.amazon.com.tr", "eu"],
  ["US", "ATVPDKIKX0DER", "sellercentral.amazon.com", "na"],
  ["CA", "A2EUQ1WTGCTBG2", "sellercentral.amazon.ca", "na"],
  ["MX", "A1AM78C64UM0Y8", "sellercentral.amazon.com.mx", "na"],
  ["BR", "A2Q3Y263D00KWC", "sellercentral.amazon.com.br", "na"],
  ["JP", "A1VC38T7YXB528", "sellercentral.amazon.co.jp", "fe"],
  ["AU", "A39IBJ37TRP1C6", "sellercentral.amazon.com.au", "fe"],
  ["SG", "A19VAU5U5O7RUS", "sellercentral.amazon.sg", "fe"],
  ["IN", "A21TJRUUN4KGV", "sellercentral.amazon.in", "eu"],
  ["AE", "A2VIGQ35RCS4UG", "sellercentral.amazon.ae", "eu"],
  ["SA", "A17E79C6D8DWNP", "sellercentral.amazon.sa", "eu"],
  ["EG", "ARBP9OOSHTCHU", "sellercentral.amazon.eg", "eu"],
  ["ZA", "AE08WJ6YKNBMC", "sellercentral.amazon.co.za", "eu"],
].map(([countryCode, marketplaceId, host, region]) => ({countryCode, marketplaceId, sellerCentralUrl: `https://${host}`, spApiUrl: `https://sellingpartnerapi-${region}.amazon.com` }));
export const amazonV2Marketplaces = Object.fromEntries(amazonV2Markets.map(market => [market.countryCode, market.marketplaceId]));
export function amazonV2Market(marketplaceId: string) {return amazonV2Markets.find(market => market.marketplaceId === marketplaceId);}
